import {
  MOBILE_HOME_HEADER_BUTTON_HITSLOP_SIZE,
  MOBILE_HOME_HEADER_ICON_SIZE,
} from 'app/components/mobile-home-header-constants';
import { useTutorialRef } from 'app/components/tutorial-overlay';
import { Button } from 'app/design/primitives/button';

import { IconQuestionMark } from '@tabler/icons-react-native';
import { useNavigation } from 'app/hooks/navigation';
import { useAuthorize } from 'app/hooks/use-authorize';
import { useTutorialHeaderButtonStyle } from 'app/hooks/use-tutorial-header-button-style';
import { createTheme as createDSTheme } from 'app/shopify';
import { TutorialRef } from 'app/types/tutorial';
import { useTranslation } from 'react-i18next';
import { View, type ViewStyle } from 'react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { Column } from 'app/design/primitives/box';
const theme = createDSTheme();

interface HeaderHelpButtonProps {
  size?: number;
  iconSize?: number;
  style?: ViewStyle;
}

export function HeaderHelpButton({
  size = MOBILE_HOME_HEADER_BUTTON_HITSLOP_SIZE,
  iconSize = MOBILE_HOME_HEADER_ICON_SIZE,
  style,
}: HeaderHelpButtonProps) {
  const navigation = useNavigation();
  const withAuthorize = useAuthorize();
  const { viewRef: headerHelpButtonRef } = useTutorialRef(TutorialRef.HeaderHelpButton);
  const { t } = useTranslation('header');
  const tutorialButtonStyle = useTutorialHeaderButtonStyle({ tutorialRef: TutorialRef.HeaderHelpButton });

  return (
    <View ref={headerHelpButtonRef} collapsable={false} style={style}>
      <Button
        accessibilityLabel={t('helpButtonAccessibilityLabel')}
        onPress={() => withAuthorize(() => navigation.navigate('help', undefined, { pop: true }))}
        variant="plain"
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          alignItems: 'center',
          justifyContent: 'center',
          ...tutorialButtonStyle,
        }}
      >
        <Column borderColor="white-label.header.on-header" borderWidth={1} borderRadius="radius.full">
          <IconQuestionMark
            strokeWidth={ICON_STROKE_WIDTH * 1.2}
            color={theme.colors['white-label.header.on-header']}
            size={iconSize * 0.8}
          />
        </Column>
      </Button>
    </View>
  );
}
